<template>
  <div
    id="checkSpillover"
    class="modal fade confirm checkSpillover"
    :class="{ 'is-open': open }"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a @click.stop="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <h3 class="modal-title">外溢保單重要提醒</h3>
        </div>
        <div class="modal-body px_0 py_0 text-sm">
          <!-- -------------------主要區塊start ----------------------->
          <section
            class="checkSpillover__message selectCustomer MainProductPopup__section mf-textWrap pb_5"
          >
            {{ message }}
          </section>

          <!-- -------------------主要區塊end ----------------------->
        </div>
        <div class="modal-footer" style="border-top: none">
          <button
            type="submit"
            class="btn btn-primary btn-sm py_5 ml_10"
            @click.stop="$emit('close')"
          >
            確定
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    message: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      ready: false,
    };
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.checkSpillover {
  .segment {
    padding: 10px 40px 10px;
    margin-top: 0;
    margin-bottom: 10px;
    border-radius: 0;
  }
  &__message {
    padding: 29px 50px 0;
    font-size: 16px;
    line-height: 1.38;
    text-align: left;
    color: #323a45;
  }
}
</style>
